// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2nnal","label":"Category_label__3S8Zv","content":"Category_content__1HvWw","header":"Category_header__1f6y8","location":"Category_location__1pufm"};